import ReactLoading from "react-loading";

const ContentLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        margin: "auto",
        bottom: 0,
        right: 0,
        height: '50px',
        width: '50px'
      }}
    >
      <ReactLoading type="spin" color="#000" height={50} width={50} />
    </div>
  );
};

export default ContentLoader;
